import { Star } from "lucide-react";
import { REVIEW_BADGES, STATS } from "@/lib/site";
import { Container } from "@/components/common/ui";

export const StatsBand = () => (
  <section className="border-b border-neutral-200 py-14 sm:py-16" data-testid="stats-band">
    <Container>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <h2 className="text-2xl font-normal sm:text-3xl">Our proven processes and experience. Your goals.</h2>
        <div className="flex flex-wrap gap-4">
          {REVIEW_BADGES.map((r) => (
            <span key={r.id} className="flex items-center gap-1.5 text-[13px] text-neutral-600" data-testid={`review-badge-${r.id}`}>
              <span className="flex text-brass">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-3.5 w-3.5 fill-current" />)}</span>
              {r.rating} · {r.count}
            </span>
          ))}
        </div>
      </div>
      <dl className="mt-10 grid grid-cols-2 gap-y-10 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <div key={s.id} className={`pr-6 ${i ? "lg:border-l lg:border-neutral-200 lg:pl-8" : ""}`} data-testid={`stat-${s.id}`}>
            <dt className="font-display text-4xl text-ink sm:text-5xl">{s.value}</dt>
            <dd className="mt-2 max-w-[220px] text-[14px] text-neutral-600">{s.label}</dd>
          </div>
        ))}
      </dl>
    </Container>
  </section>
);
